import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
    this.state = {
      duration: 450,
      animating: false,
      expanded: true
    }
  }

  clickDestinationGroup() {
    this.toggle()
  }

  toggle() {
    if (!this.state.animating) {
      this.state.animating = true

      this.state.expanded = !this.state.expanded
      this.element.setAttribute('aria-expanded', this.state.expanded)
      this.element.classList.toggle('active', this.state.expanded)
      const toggleButton = this.element.querySelector('.destinations-group__trigger')
      toggleButton.setAttribute('aria-expanded', this.state.expanded)
      setTimeout(() =>
        this.state.animating = false
        , this.state.duration * 1.5
      )
    }
  }


}